import { call, put, takeLatest } from 'redux-saga/effects';

import {
	FETCH_PATIENT_PROFILE,
	FETCH_PATIENT_CALENDAR,
	FETCH_PATIENT_GROUPS,
	FETCH_PATIENT_OQ,
} from './constants';
import {
	fetchPatientProfileSuccess,
	fetchPatientProfileError,
	fetchPatientCalendarSuccess,
	fetchPatientCalendarError,
	fetchPatientGroupsSuccess,
	fetchPatientGroupsError,
	fetchPatientOqSuccess,
	fetchPatientOqError,
} from './actions';
import {
	fetchPatientProfileApi,
	fetchPatientCalendarApi,
	fetchPatientGroupsApi,
	fetchPatientOqApi,
} from './api';

function* profileSaga(action) {
	try {
		const response = yield call(fetchPatientProfileApi, action.patientId);
		yield put(fetchPatientProfileSuccess(response.data));
	} catch (err) {
		yield put(fetchPatientProfileError(err));
	}
}

function* calendarSaga(action) {
	try {
		const response = yield call(fetchPatientCalendarApi, action.patientId);
		yield put(fetchPatientCalendarSuccess(response.data));
	} catch (err) {
		yield put(fetchPatientCalendarError(err));
	}
}

function* groupsSaga(action) {
	try {
		const response = yield call(fetchPatientGroupsApi, action.patientId);
		yield put(fetchPatientGroupsSuccess(response.data));
	} catch (err) {
		yield put(fetchPatientGroupsError(err));
	}
}

function* oqSaga(action) {
	try {
		const response = yield call(fetchPatientOqApi, action.patientId);
		yield put(fetchPatientOqSuccess(response.data));
	} catch (err) {
		yield put(fetchPatientOqError(err));
	}
}

export default function* referrerPatientViewSaga() {
	yield takeLatest(FETCH_PATIENT_PROFILE, profileSaga);
	yield takeLatest(FETCH_PATIENT_CALENDAR, calendarSaga);
	yield takeLatest(FETCH_PATIENT_GROUPS, groupsSaga);
	yield takeLatest(FETCH_PATIENT_OQ, oqSaga);
}
